package link.erpango.quip.catalog.sections

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.Divider
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Settings
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.theme.QuipDimens
import link.erpango.quip.ui.components.QuipCard
import link.erpango.quip.ui.components.QuipInfoRow
import link.erpango.quip.ui.components.QuipPrimaryButton
import link.erpango.quip.ui.components.QuipSecondaryButton
import link.erpango.quip.ui.components.QuipSectionHeader
import link.erpango.quip.ui.components.QuipTextButton
import link.erpango.quip.ui.components.QuipVehicleCard

@Composable
fun CatalogComponentsSection() {
    LazyColumn(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = QuipDimens.padding16, vertical = QuipDimens.padding12),
        verticalArrangement = Arrangement.spacedBy(QuipDimens.padding20),
    ) {
        item { SectionHeaders() }
        item { Cards() }
        item { Buttons() }
        item { InfoRows() }
        item { StatusColors() }
        item { Spacer(Modifier.height(QuipDimens.padding24)) }
    }
}

@Composable
private fun SectionHeaders() {
    QuipSectionHeader(title = "Section Headers")
    Spacer(Modifier.height(QuipDimens.padding8))
    QuipCard {
        Column(verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
            QuipSectionHeader(title = "Header sin icono")
            Divider(color = QuipColors.colorBackground)
            QuipSectionHeader(title = "Header con icono", icon = Icons.Default.Settings)
        }
    }
}

@Composable
private fun Cards() {
    QuipSectionHeader(title = "Cards")
    Spacer(Modifier.height(QuipDimens.padding8))
    Column(verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
        QuipCard {
            Column {
                Text(
                    "QuipCard — elevation 2dp, radius 12dp",
                    style = MaterialTheme.typography.subtitle2,
                    color = QuipColors.colorText,
                )
                Spacer(Modifier.height(4.dp))
                Text(
                    "Contenedor estándar para agrupar información relacionada.",
                    style = MaterialTheme.typography.body2,
                    color = QuipColors.colorTextSecondary,
                )
            }
        }
        QuipVehicleCard {
            Column {
                Text(
                    "QuipVehicleCard — elevation 4dp, radius 16dp",
                    style = MaterialTheme.typography.subtitle2,
                    color = QuipColors.colorText,
                )
                Spacer(Modifier.height(4.dp))
                Text(
                    "Variante destacada para vehículos, con más elevación y radio.",
                    style = MaterialTheme.typography.body2,
                    color = QuipColors.colorTextSecondary,
                )
            }
        }
    }
}

@Composable
private fun Buttons() {
    QuipSectionHeader(title = "Buttons")
    Spacer(Modifier.height(QuipDimens.padding8))
    QuipCard {
        Column(verticalArrangement = Arrangement.spacedBy(QuipDimens.padding12)) {
            QuipPrimaryButton(text = "Primary Button", onClick = {})
            QuipPrimaryButton(text = "Primary deshabilitado", onClick = {}, enabled = false)
            Divider(color = QuipColors.colorBackground)
            QuipSecondaryButton(text = "Secondary Button", onClick = {})
            QuipSecondaryButton(text = "Secondary con icono", onClick = {}, icon = Icons.Default.Build)
            Divider(color = QuipColors.colorBackground)
            Row(horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
                QuipTextButton(text = "Text Button", onClick = {}, modifier = Modifier.weight(1f))
                QuipTextButton(
                    text = "Con icono",
                    onClick = {},
                    icon = Icons.Default.Info,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}

@Composable
private fun InfoRows() {
    QuipSectionHeader(title = "Info Rows")
    Spacer(Modifier.height(QuipDimens.padding8))
    QuipCard {
        Column {
            QuipInfoRow(label = "Marca", value = "Toyota")
            Divider(color = QuipColors.colorBackground, thickness = 1.dp)
            QuipInfoRow(label = "Motor", value = "1.2 8NR", icon = Icons.Default.Settings)
            Divider(color = QuipColors.colorBackground, thickness = 1.dp)
            QuipInfoRow(label = "Kilometraje", value = "87.450 km")
        }
    }
}

@Composable
private fun StatusColors() {
    QuipSectionHeader(title = "Colores semánticos")
    Spacer(Modifier.height(QuipDimens.padding8))
    QuipCard {
        Column(verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
            Row(horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
                StatusChip(label = "Éxito", color = QuipColors.colorSuccess, modifier = Modifier.weight(1f))
                StatusChip(label = "Advertencia", color = QuipColors.colorWarning, modifier = Modifier.weight(1f))
                StatusChip(label = "Error", color = QuipColors.colorError, modifier = Modifier.weight(1f))
            }
            Text(
                "Uso: vencido → error, próximo → warning, al día → success, sin fecha → textSecondary (α 0.6).",
                style = MaterialTheme.typography.caption,
                color = QuipColors.colorTextSecondary,
            )
        }
    }
}

@Composable
private fun StatusChip(label: String, color: androidx.compose.ui.graphics.Color, modifier: Modifier = Modifier) {
    androidx.compose.foundation.layout.Box(
        modifier = modifier
            .height(32.dp)
            .padding(horizontal = 2.dp),
        contentAlignment = androidx.compose.ui.Alignment.Center,
    ) {
        androidx.compose.material.Surface(
            color = color.copy(alpha = 0.18f),
            shape = androidx.compose.foundation.shape.RoundedCornerShape(QuipDimens.cornerRadius8),
            modifier = Modifier.fillMaxWidth().height(32.dp),
        ) {
            androidx.compose.foundation.layout.Box(contentAlignment = androidx.compose.ui.Alignment.Center) {
                Text(
                    text = label,
                    style = MaterialTheme.typography.caption,
                    color = color,
                )
            }
        }
    }
}
